module.exports = __webpack_public_path__ + "static/media/41-15.80ceec3c.mp3";